module.exports = __webpack_public_path__ + "img/隨緣自強.bc996d45.jpg";